let isOpen = false;
if ('serviceWorker' in navigator && isOpen) {
    navigator.serviceWorker.register(`${process.env.BASE_URL}uedc-sw.js`, {scope: '/'}).then(function (registration) {
        // 注册成功
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
    }).catch(function (err) {
        // 注册失败 :(
        console.log('ServiceWorker registration failed: ', err);
    });
}